/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type FollowSearchButton_favoritesConnection$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedFollowSearchBanner_user$ref: FragmentReference;
export type SbSharedFollowSearchBanner_user = {|
  +serviceId: ?string,
  +favorites: ?{|
    +$fragmentRefs: FollowSearchButton_favoritesConnection$ref
  |},
  +$refType: SbSharedFollowSearchBanner_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedFollowSearchBanner_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchTypes",
      "type": "[types]"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "favorites",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages",
          "type": "[String]"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes",
          "type": "[types]"
        }
      ],
      "concreteType": "favoritesConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FollowSearchButton_favoritesConnection",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '942ff04694df833aa61eda4c9f264e45';
module.exports = node;
